<template>
    <div>
        <TerminalUpdate type="batchUpdate"></TerminalUpdate>
    </div>
</template>

<script>
    import TerminalUpdate from '@/components/terminalUpdate/snBatchIssue';
    export default {
        components:{
            TerminalUpdate
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        
    };
</script>

<style scoped>

</style>
